import { TIconName } from 'app/libs/icons/icons.class'

export enum SupportedViews {
  table,
  grid
}

export const SUPPORTED_VIEWS_ICONS: Array<TIconName> = ['table', 'gridOutline']
